(function(Manogi, $, undefined) {

    //Private

    //Public





    Manogi.switchPaymentKind = function() {
        var payment_kind = $('input[name=payment_kind]:checked').val();
        $('input[name=payment_kind]').parent().find('.js-explanation').addClass('u-hidden');
        $('input[name=payment_kind]:checked').parent().find('.js-explanation').removeClass('u-hidden');

        $('.js-payment-form').addClass('u-hidden');
        $('.js-payment-form[data-payment_kind="'+payment_kind+'"]').removeClass('u-hidden');
    };



}( window.Manogi = window.Manogi || {}, jQuery ));
